// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
import Message from '@/components/message'
import 'weui'
// import '@/styles/common.scss'
// import(`@/styles/${process.env.LANG}/common.scss`)
import i18n from "./lang";
import { isIOS, setThemeColor } from '@/utils'

if (isIOS) {
  document.body.classList.add('is-ios');
}
if (window.devicePixelRatio >= 1.5) {
  document.body.classList.add('dpr-ge2');
}


import(`@/styles/${process.env.LANG}/index.scss`)

/* 设置语言。并根据语言引入样式文件 */
if (process.env.LANG === "zh" || process.env.LANG === "en"){
  document.documentElement.lang = process.env.LANG
}else if (process.env.LANG === "cosZh"){
  document.documentElement.lang = 'zh'
}

// 设置主题色
setThemeColor()

// i18n.locale = 'en'
// import('@/styles/en/index.scss')
// document.documentElement.lang = 'en'


// i18n.locale = 'zh'
// import('@/styles/zh/index.scss')
// document.documentElement.lang = 'zh'

Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(Message)
Vue.http.options.emulateJSON = true

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js